import React from 'react'
import {
    Box,
    IconButton,
    Typography,
    Divider,
    ThemeProvider,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import PDFWebViewComponent from '../../../components/PDFWebViewComponent'
import { ArtosTheme } from '../../../components/Themes'
import OnlyOfficeViewerComponent from '../../DocumentPage/DocViewer'
import { v4 as uuidv4 } from 'uuid'

const InconsistencyPreview = ({ 
    fileUrl, 
    page, 
    onClose, 
    title, 
    selectedText = null,
    isPDFOverride = false,
    extensionOverride = null
}) => {
    const documentKey = uuidv4()
    
    // Determine file type based on the URL extension
    let isPDF = fileUrl && fileUrl.toLowerCase().includes('.pdf')

    if (isPDFOverride) {
        isPDF = true
    }
    let fileExtension = fileUrl ? fileUrl.split('.').pop().toLowerCase() : ''
    if (fileExtension.includes('?')) {
        fileExtension = fileExtension.split('?')[0]
    }
    
    console.log('fileUrl:', fileUrl)
    console.log('isPDF:', isPDF)
    console.log('fileExtension:', fileExtension)

    return (
        <ThemeProvider theme={ArtosTheme}>
            <Box
                sx={{
                    height: '100%',
                    width: '100%',
                    bgcolor: 'background.paper',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        p: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        bgcolor: 'background.default',
                    }}
                >
                    <Typography variant="h6" sx={{ fontSize: '1rem' }}>
                        {title || 'View Document'}
                    </Typography>
                    <IconButton
                        onClick={onClose}
                        size="small"
                        sx={{
                            '&:hover': {
                                bgcolor: 'rgba(0, 0, 0, 0.04)',
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Divider />

                {/* Document Viewer */}
                <Box sx={{ flex: 1, overflow: 'hidden', marginLeft: 0.5 }}>
                    <Box
                        sx={{
                            height: '100%',
                            bgcolor: 'background.default',
                            borderRadius: 1,
                            overflow: 'hidden',
                            p: 1,
                        }}
                    >
                        {fileUrl ? (
                            isPDF ? (
                                <PDFWebViewComponent
                                    initialFile={fileUrl}
                                    page={page}
                                    selectedText={selectedText}
                                    extensionOverride={extensionOverride}
                                />
                            ) : (
                                <OnlyOfficeViewerComponent
                                    documentId='docxEditorEmbedded'
                                    initialFile={fileUrl}
                                    onLoaded={() => {
                                        console.log('Document loaded')
                                    }}
                                    documentName={title}
                                    documentKey={documentKey}
                                    displayType='embedded'
                                />
                            )
                        ) : (
                            <Box sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                height: '100%',
                                color: 'text.secondary'
                            }}>
                                Loading document...
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>
        </ThemeProvider>
    )
}

export default InconsistencyPreview
